import React from "react";
import PlusMinButtons from "../../../common/PlusMinButtons";
import TextInput from "../../../common/TextInput";
import Row from "../../../common/Row";
import PropTypes from "prop-types";
import {getTochtTypeText } from "../../../../util/tochtTypeHelper";

const LusComponent = props => {
	const {
		naam,
		minButtonEnabled,
		plusButtonEnabled,
		disabled,
		onPlusButtonClick,
		onMinButtonClick,
		onChange,
		index,
		errors,
		validationMessageType
	} = props;

	const tochtTypeText = getTochtTypeText();

	return (
		<Row>
			<TextInput
				name={"naam_" + index}
				label={`Naam ${tochtTypeText.LusTypeSingular}`}
				size={6}
				value={naam}
				onChange={onChange}
				validationMessage={errors ? errors["naam"] : ""}
				validationMessageType={validationMessageType}
				disabled={disabled}
			/>
			<PlusMinButtons
				minButtonEnabled={minButtonEnabled && !disabled}
				plusButtonEnabled={plusButtonEnabled && !disabled}
				onMinButtonClick={onMinButtonClick}
				onPlusButtonClick={onPlusButtonClick}
				size={1}
			/>
		</Row>
	);
};

LusComponent.propTypes = {
	naam: PropTypes.string,
	minButtonEnabled: PropTypes.bool,
	plusButtonEnabled: PropTypes.bool,
	disabled: PropTypes.bool,
	onPlusButtonClick: PropTypes.func.isRequired,
	onMinButtonClick: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	index: PropTypes.number,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string,
	isVolledig: PropTypes.bool
};

export default LusComponent;
